/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { patchState, signalStoreFeature, type, withMethods, withState } from "@ngrx/signals";
import { debounceTime, tap, distinctUntilChanged } from "rxjs/operators";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { pipe } from "rxjs";
import { SetPaginationParams } from "./pagination.feature";
import { StoreCollection } from "src/app/enums";

export interface SearchState<K extends StoreCollection> {
  searchTerms: Record<K, string>;
}

export function withSearch<K extends StoreCollection>(initialState: SearchState<K>, hasOffsetIndex = true) {
  return signalStoreFeature(
    { methods: type<{ setPagination(params: SetPaginationParams, collection: K): void }>() },
    withState<SearchState<K>>(initialState),
    withMethods(store => ({
      setSearch(searchTerm: string, collection: K): void {
        patchState(store, { searchTerms: { ...store.searchTerms(), [collection]: searchTerm } });
      },
      debounceSetSearch: rxMethod<{ searchTerm: string; collection: K }>(
        pipe(
          distinctUntilChanged(),
          debounceTime(500),
          tap(({ searchTerm, collection }) => {
            if (searchTerm) store.setPagination({ page: hasOffsetIndex ? 1 : 0 }, collection);
            patchState(store, { searchTerms: { ...store.searchTerms(), [collection]: searchTerm } });
          }),
        ),
      ),
    })),
  );
}
